<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import SectionHeader from "../components/SectionHeader.svelte";
    import StripeGate from "../components/StripeGate.svelte";
    import LinkClientCard from "./clients/LinkClientCard.svelte";
    import UsersTable from "./clients/UsersTable.svelte";

    const store = getDashboardCtx();
</script>

<div class="dashStack">
    <SectionHeader id="clients" />
    <LinkClientCard />
    <div class="referralsPanel">
        {#if store.isStripeConfigured}
            <UsersTable />
        {:else}
            <StripeGate />
        {/if}
    </div>
</div>
